import { atom } from 'recoil'
import { RootOutcomes } from 'src/types'

export const atomRootOutcomes = atom<RootOutcomes>({
  key: 'rootOutcomes',
  default: {},
})
